import React, { useState } from 'react';

const DaskKartOdemeModal = ({ isOpen, onClose, selectedPrice, teklifKodu, onPaymentComplete }) => {
  const [kartBilgileri, setKartBilgileri] = useState({
    kartNo: '',
    sonKullanmaAy: '',
    sonKullanmaYil: '',
    kartUstundekiIsim: '',
    guvenlikNo: ''
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const validateKartBilgileri = () => {
    const errors = {};
    
    // Kart numarası kontrolü (16 hane)
    const kartNo = kartBilgileri.kartNo.replace(/\s/g, '');
    if (!kartNo || kartNo.length !== 16 || !/^\d+$/.test(kartNo)) {
      errors.kartNo = 'Geçerli bir kart numarası giriniz (16 hane)';
    }

    // Son kullanma ay kontrolü
    const ay = parseInt(kartBilgileri.sonKullanmaAy);
    if (!ay || ay < 1 || ay > 12) {
      errors.sonKullanmaAy = 'Geçerli bir ay giriniz (01-12)';
    }

    // Son kullanma yıl kontrolü
    const yil = parseInt(kartBilgileri.sonKullanmaYil);
    const currentYear = new Date().getFullYear();
    if (!yil || yil < currentYear || yil > currentYear + 20) {
      errors.sonKullanmaYil = 'Geçerli bir yıl giriniz';
    }

    // Kart üzerindeki isim kontrolü
    if (!kartBilgileri.kartUstundekiIsim || kartBilgileri.kartUstundekiIsim.length < 2) {
      errors.kartUstundekiIsim = 'Kart üzerindeki ismi giriniz';
    }

    // Güvenlik numarası kontrolü (3 hane)
    if (!kartBilgileri.guvenlikNo || kartBilgileri.guvenlikNo.length !== 3 || !/^\d+$/.test(kartBilgileri.guvenlikNo)) {
      errors.guvenlikNo = 'Geçerli bir güvenlik numarası giriniz (3 hane)';
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!validateKartBilgileri()) {
      return;
    }
  
    setLoading(true);

    try {
      const response = await fetch(`${window.location.protocol}//${window.location.host}/dask-3d-secure.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          teklifKodu: teklifKodu,
          secilenTaksit: selectedPrice.taksit_sayisi,
          kartBilgileri: {
            kartNo: kartBilgileri.kartNo.replace(/\s/g, ''),
            sonKullanmaAy: kartBilgileri.sonKullanmaAy,
            sonKullanmaYil: kartBilgileri.sonKullanmaYil,
            kartUstundekiIsim: kartBilgileri.kartUstundekiIsim,
            guvenlikNo: kartBilgileri.guvenlikNo
          }
        })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || '3D Secure başlatma hatası');
      }
  
      // 3D Secure doğrulamasını başlat
      start3DSecureProcess(data.tdsDogrulamaBilgi);
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const start3DSecureProcess = (tdsDogrulamaBilgi) => {
    // 3D Secure POST formu oluştur ve gönder
    let formHtml = "";
    
    for (let i = 0; i < tdsDogrulamaBilgi.FormParametreleri.length; i++) {
      const param = tdsDogrulamaBilgi.FormParametreleri[i];
      formHtml += `<input type="hidden" name="${param.Ad}" value="${param.Deger}" />`;
    }
    
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = tdsDogrulamaBilgi.Url;
    form.innerHTML = formHtml;
    form.style.display = 'none';
    
    document.body.appendChild(form);
    form.submit();
    
    // Modal'ı kapat
    onClose();
  };

  const formatKartNo = (value) => {
    // Kart numarasını 4'lü gruplar halinde formatla
    const cleaned = value.replace(/\s/g, '');
    const match = cleaned.match(/\d{1,4}/g);
    return match ? match.join(' ') : '';
  };

  if (!isOpen) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(price);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Kart ile Ödeme</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
            disabled={loading}
          >
            ✕
          </button>
        </div>

        {/* Ödeme Özeti */}
        <div className="mb-4 p-3 bg-blue-50 rounded-lg">
          <h3 className="font-medium text-blue-900 mb-1">Ödeme Özeti</h3>
          <div className="text-sm text-blue-700">
            <div className="flex justify-between">
              <span>{selectedPrice?.taksit_tipi}</span>
              <span className="font-medium">{formatPrice(selectedPrice?.brut_prim)}</span>
            </div>
          </div>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Kart Numarası */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kart Numarası *
            </label>
            <input
              type="text"
              placeholder="1234 5678 9012 3456"
              className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                ${validationErrors.kartNo ? 'border-red-500' : 'border-gray-300'}`}
              maxLength="19"
              value={formatKartNo(kartBilgileri.kartNo)}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, '');
                if (value.length <= 16) {
                  setKartBilgileri({ ...kartBilgileri, kartNo: value });
                  if (validationErrors.kartNo) {
                    setValidationErrors({ ...validationErrors, kartNo: '' });
                  }
                }
              }}
            />
            {validationErrors.kartNo && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.kartNo}</p>
            )}
          </div>

          {/* Son Kullanma Tarihi */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Ay *
              </label>
              <select
                className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                  ${validationErrors.sonKullanmaAy ? 'border-red-500' : 'border-gray-300'}`}
                value={kartBilgileri.sonKullanmaAy}
                onChange={(e) => {
                  setKartBilgileri({ ...kartBilgileri, sonKullanmaAy: e.target.value });
                  if (validationErrors.sonKullanmaAy) {
                    setValidationErrors({ ...validationErrors, sonKullanmaAy: '' });
                  }
                }}
              >
                <option value="">Ay</option>
                {Array.from({ length: 12 }, (_, i) => (
                  <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                    {String(i + 1).padStart(2, '0')}
                  </option>
                ))}
              </select>
              {validationErrors.sonKullanmaAy && (
                <p className="mt-1 text-sm text-red-600">{validationErrors.sonKullanmaAy}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Yıl *
              </label>
              <select
                className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                  ${validationErrors.sonKullanmaYil ? 'border-red-500' : 'border-gray-300'}`}
                value={kartBilgileri.sonKullanmaYil}
                onChange={(e) => {
                  setKartBilgileri({ ...kartBilgileri, sonKullanmaYil: e.target.value });
                  if (validationErrors.sonKullanmaYil) {
                    setValidationErrors({ ...validationErrors, sonKullanmaYil: '' });
                  }
                }}
              >
                <option value="">Yıl</option>
                {Array.from({ length: 10 }, (_, i) => {
                  const year = new Date().getFullYear() + i;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
              {validationErrors.sonKullanmaYil && (
                <p className="mt-1 text-sm text-red-600">{validationErrors.sonKullanmaYil}</p>
              )}
            </div>
          </div>

          {/* Kart Üzerindeki İsim */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Kart Üzerindeki İsim *
            </label>
            <input
              type="text"
              placeholder="JOHN DOE"
              className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                ${validationErrors.kartUstundekiIsim ? 'border-red-500' : 'border-gray-300'}`}
              value={kartBilgileri.kartUstundekiIsim}
              onChange={(e) => {
                setKartBilgileri({ ...kartBilgileri, kartUstundekiIsim: e.target.value.toUpperCase() });
                if (validationErrors.kartUstundekiIsim) {
                  setValidationErrors({ ...validationErrors, kartUstundekiIsim: '' });
                }
              }}
            />
            {validationErrors.kartUstundekiIsim && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.kartUstundekiIsim}</p>
            )}
          </div>

          {/* Güvenlik Numarası */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Güvenlik Numarası (CVV) *
            </label>
            <input
              type="text"
              placeholder="123"
              className={`w-full p-3 border rounded focus:outline-none focus:ring-2 focus:ring-blue-600
                ${validationErrors.guvenlikNo ? 'border-red-500' : 'border-gray-300'}`}
              maxLength="3"
              value={kartBilgileri.guvenlikNo}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                setKartBilgileri({ ...kartBilgileri, guvenlikNo: value });
                if (validationErrors.guvenlikNo) {
                  setValidationErrors({ ...validationErrors, guvenlikNo: '' });
                }
              }}
            />
            {validationErrors.guvenlikNo && (
              <p className="mt-1 text-sm text-red-600">{validationErrors.guvenlikNo}</p>
            )}
          </div>

          {/* Test Kart Bilgisi */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
            <h4 className="text-sm font-medium text-yellow-800 mb-1">Test Kartı</h4>
            <p className="text-xs text-yellow-700">
              <strong>Kart No:</strong> 4546 7112 3456 7894<br/>
              <strong>Son Kullanma:</strong> 12/2026<br/>
              <strong>CVV:</strong> 000<br/>
              <strong>3D Şifre:</strong> a
            </p>
          </div>

          {/* Butonlar */}
          <div className="flex space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg transition hover:bg-gray-300 disabled:opacity-50"
            >
              İptal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-blue-600 text-white py-3 rounded-lg transition hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? 'İşleniyor...' : '3D Secure ile Öde'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DaskKartOdemeModal;